import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=dd2360aa"
import script from "./GroupsList.vue?vue&type=script&lang=js"
export * from "./GroupsList.vue?vue&type=script&lang=js"
import style0 from "./GroupsList.vue?vue&type=style&index=0&id=dd2360aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports